/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ProductTestVariant_item = {
    readonly serviceId: string | null;
    readonly " $fragmentRefs": FragmentRefs<"ProductSwiper_item">;
    readonly " $refType": "ProductTestVariant_item";
};
export type ProductTestVariant_item$data = ProductTestVariant_item;
export type ProductTestVariant_item$key = {
    readonly " $data"?: ProductTestVariant_item$data;
    readonly " $fragmentRefs": FragmentRefs<"ProductTestVariant_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "ProductTestVariant_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "photosLimit",
      "type": "Int",
      "defaultValue": 2
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "ProductSwiper_item",
      "args": [
        {
          "kind": "Variable",
          "name": "photosLimit",
          "variableName": "photosLimit"
        }
      ]
    }
  ]
};
(node as any).hash = 'ffb10a471ec80fdb83b83cb06a5a1977';
export default node;
